<template>
  <div>
    <fieldset style="width: 100%" class="mt-3 mb-0 custom-fieldset">
      <legend>
        <template v-if="$store.state.DelegationOrder.readonly !== true">
          <span style="width: 0; display: inline-flex; position: relative; left: -75px;"
            ><v-btn fab x-small color="accent" @click="newTravelService"><v-icon small>fa-plus</v-icon></v-btn></span
          >
          <delegation-order-travel-service-import
            :travel_service_order_ids.sync="travelServiceOrderIds"
            style="width: 0; display: inline-flex; position: relative; left: -40px; top: -2px;"
          >
            <v-btn fab x-small color="grey darken-2" dark><v-icon small>fa-file-import</v-icon></v-btn>
          </delegation-order-travel-service-import>
        </template>
        {{ $t("delegationOrder.assignedTravelOrders") }}
      </legend>
      <template v-if="travelServiceOrderIds.length === 0">{{ $t("delegationOrder.noAssignedTravelOrders") }}</template>
      <div v-else>
        <order-list-data-table
          :travel-service-orders="travelServiceOrders"
          unpin
          @changed="downloadTravelServiceSelectedList()"
          @edit="id => editTravelService(id)"
          @choose-offer="id => chooseOfferTravelService(id)"
          @approval="id => approvalTravelService(id)"
          @booked="id => bookedTravelService(id)"
          @unpin="unpinMethod"
          @message="val => $router.push('/travel-service/item-details/' + val)"
        />
      </div>
    </fieldset>
    <v-dialog v-model="newTravelServiceOrderDialog" max-width="90%">
      <v-card class="pt-3">
        <v-card-text>
          <order-services @cancel="newTravelServiceOrderDialog = false" @saved="ids => saved(ids)" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DelegationOrderTravelServiceImport from "./DelegationOrderTravelServiceImport";
import OrderServices from "../TravelService/OrderServices";
import OrderListDataTable from "../TravelService/OrderListDataTable";
export default {
  name: "DelegationOrderTravelService",
  components: { OrderListDataTable, OrderServices, DelegationOrderTravelServiceImport },
  props: {
    travelServiceOrderIds: { required: true }
  },
  watch: {
    travelServiceOrderIds() {
      this.downloadTravelServiceSelectedList();
    }
  },
  data: () => ({
    newTravelServiceOrderDialog: false,
    travelServiceOrders: []
  }),
  methods: {
    saved(ids) {
      this.newTravelServiceOrderDialog = false;
      for (let id of ids) {
        this.travelServiceOrderIds.push(id);
      }
    },
    unpinMethod(id) {
      this.travelServiceOrderIds.splice(this.travelServiceOrderIds.indexOf(id), 1);
      this.$emit("update:travelServiceOrderIds", this.travelServiceOrderIds);
    },
    findUserId() {
      for (let travelServiceOrder of this.travelServiceOrders) {
        for (let travelServiceOrderItem of travelServiceOrder.travel_service_items) {
          for (let passenger of travelServiceOrderItem.passengers) {
            if (passenger.company_user_id !== null) return passenger.company_user_id;
          }
        }
      }
      return null;
    },
    findStartDate() {
      let startDate = null;
      for (let travelServiceOrder of this.travelServiceOrders) {
        for (let travelServiceOrderItem of travelServiceOrder.travel_service_items) {
          if (travelServiceOrderItem.rail !== null) {
            if (startDate == null || startDate > travelServiceOrderItem.rail.start_date) {
              startDate = travelServiceOrderItem.rail.start_date;
            }
          } else if (travelServiceOrderItem.flight !== null) {
            if (startDate == null || startDate > travelServiceOrderItem.flight.start_date) {
              startDate = travelServiceOrderItem.flight.start_date;
            }
          } else if (travelServiceOrderItem.hotel !== null) {
            if (startDate == null || startDate > travelServiceOrderItem.hotel.start_date) {
              startDate = travelServiceOrderItem.hotel.start_date;
            }
          } else if (travelServiceOrderItem.car !== null) {
            if (startDate == null || startDate > travelServiceOrderItem.car.start_date) {
              startDate = travelServiceOrderItem.car.start_date;
            }
          }
        }
      }
      return startDate;
    },
    findEndDate() {
      let endDate = null;
      for (let travelServiceOrder of this.travelServiceOrders) {
        for (let travelServiceOrderItem of travelServiceOrder.travel_service_items) {
          if (travelServiceOrderItem.rail !== null) {
            if (travelServiceOrderItem.rail.return_date !== null && (endDate == null || endDate < travelServiceOrderItem.rail.return_date)) {
              endDate = travelServiceOrderItem.rail.return_date;
            }
          } else if (travelServiceOrderItem.flight !== null) {
            if (travelServiceOrderItem.flight.return_date !== null && (endDate == null || endDate < travelServiceOrderItem.flight.return_date)) {
              endDate = travelServiceOrderItem.flight.return_date;
            }
          } else if (travelServiceOrderItem.hotel !== null) {
            if (endDate == null || endDate < travelServiceOrderItem.hotel.end_date) {
              endDate = travelServiceOrderItem.hotel.end_date;
            }
          } else if (travelServiceOrderItem.car !== null) {
            if (endDate == null || endDate < travelServiceOrderItem.car.end_date) {
              endDate = travelServiceOrderItem.car.end_date;
            }
          }
        }
      }
      return endDate;
    },
    findExternalCustomerId() {
      for (let travelServiceOrder of this.travelServiceOrders) {
        if (travelServiceOrder.external_customer_id !== null) return travelServiceOrder.external_customer_id;
      }
      return null;
    },
    findProjectId() {
      for (let travelServiceOrder of this.travelServiceOrders) {
        if (travelServiceOrder.external_customer_id !== null) return travelServiceOrder.project_id;
      }
      return null;
    },
    findCostCentreId() {
      for (let travelServiceOrder of this.travelServiceOrders) {
        for (let travelServiceOrderItem of travelServiceOrder.travel_service_items) {
          if (travelServiceOrderItem.cost_centre_id !== null) {
            return travelServiceOrderItem.cost_centre_id;
          }
        }
      }
      return null;
    },
    findDestination() {
      let destination = [];
      for (let travelServiceOrder of this.travelServiceOrders) {
        for (let travelServiceOrderItem of travelServiceOrder.travel_service_items) {
          if (travelServiceOrderItem.rail !== null) {
            if (!destination.includes(travelServiceOrderItem.rail.end_place_id)) {
              destination.push(travelServiceOrderItem.rail.end_place_id);
            }
          } else if (travelServiceOrderItem.flight !== null) {
            if (!destination.includes(travelServiceOrderItem.flight.end_place_id)) {
              destination.push(travelServiceOrderItem.flight.end_place_id);
            }
          } else if (travelServiceOrderItem.hotel !== null) {
            if (!destination.includes(travelServiceOrderItem.hotel.place_id)) {
              destination.push(travelServiceOrderItem.hotel.place_id);
            }
          } else if (travelServiceOrderItem.car !== null) {
            if (!destination.includes(travelServiceOrderItem.car.start_place_id)) {
              destination.push(travelServiceOrderItem.car.start_place_id);
            }
            if (travelServiceOrderItem.car.end_place_id !== null && !destination.includes(travelServiceOrderItem.car.end_place_id)) {
              destination.push(travelServiceOrderItem.car.end_place_id);
            }
          }
        }
      }
      return destination;
    },
    prepareImportObject() {
      return {
        user_id: this.findUserId(),
        start_date: this.findStartDate(),
        end_date: this.findEndDate(),
        external_customer_id: this.findExternalCustomerId(),
        project_id: this.findProjectId(),
        cost_centre_id: this.findCostCentreId(),
        destinations: this.findDestination()
      };
    },
    importOnDelegationOrder(importObject) {
      let delegationOrder = this.$store.state.DelegationOrder.delegationOrderEdited;
      if (importObject.user_id !== null) {
        delegationOrder.user_id = importObject.user_id;
      }
      if (importObject.end_date !== null) {
        delegationOrder.end_date = importObject.end_date + " ";
      }
      if (importObject.start_date !== null) {
        delegationOrder.start_date = importObject.start_date + " ";
      }
      if (importObject.external_customer_id !== null) {
        delegationOrder.external_customer_id = importObject.external_customer_id;
        delegationOrder.project_id = importObject.project_id;
      }
      if (importObject.cost_centre_id !== null) {
        delegationOrder.cost_centre_id = importObject.cost_centre_id;
      }
      if (importObject.destinations.length > 0) {
        delegationOrder.destination = importObject.destinations;
      }
      this.$store.commit("DelegationOrder/setEditedDelegationOrder", delegationOrder);
    },
    downloadTravelServiceSelectedList() {
      if (this.travelServiceOrderIds.length > 0) {
        this.axios.get("/travel-service/get-service-order-selected-list", { params: { ids: this.travelServiceOrderIds } }).then(resp => {
          this.travelServiceOrders = resp.data;
          if (this.$store.state.DelegationOrder.delegationOrderEdited.id === null) {
            let importObject = this.prepareImportObject();
            this.$store
              .dispatch("confirmDialog", {
                content: this.$t("delegationOrder.importFromServiceOrderDialog.content"),
                title: this.$t("delegationOrder.importFromServiceOrderDialog.title")
              })
              .then(() => {
                this.importOnDelegationOrder(importObject);
              });
          }
        });
      }
    },
    editTravelService(id) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("delegationOrder.goToTravelOrderWarning.content"),
          title: this.$t("delegationOrder.goToTravelOrderWarning.title")
        })
        .then(() => {
          this.$router.push("/travel-service/edit/" + id);
        });
    },
    chooseOfferTravelService(id) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("delegationOrder.goToTravelOrderWarning.content"),
          title: this.$t("delegationOrder.goToTravelOrderWarning.title")
        })
        .then(() => {
          this.$router.push("/travel-service/choose-offer/" + id);
        });
    },
    approvalTravelService(id) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("delegationOrder.goToTravelOrderWarning.content"),
          title: this.$t("delegationOrder.goToTravelOrderWarning.title")
        })
        .then(() => {
          this.$router.push("/travel-service/approval/" + id);
        });
    },
    bookedTravelService(id) {
      this.$store
        .dispatch("confirmDialog", {
          content: this.$t("delegationOrder.goToTravelOrderWarning.content"),
          title: this.$t("delegationOrder.goToTravelOrderWarning.title")
        })
        .then(() => {
          this.$router.push("/travel-service/booked/" + id);
        });
    },
    newTravelService() {
      this.$store.dispatch("TravelService/createNewTravelServiceOrder");
      this.newTravelServiceOrderDialog = true;
    }
  }
};
</script>

<style scoped></style>
